'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    AnalyticsController.$inject = ['$q', '$translate', 'iotService'];
    angular.module('app.analytics').component('analytics', {
        template: '<style>\n.nvd3-error-chart .nv-line {\n    stroke-opacity: 0.25;\n}\n</style><div style="padding: 2em 2em;" translate-namespace="analytics"><div class="container-fluid"><div class="row"><div class="col-lg-3"><aside class="well"><div class="row"><div class="col-lg-12"><div class="form-group"><label for="acl-modality" translate>.Sensor</label><select id="alc-modality" class="form-control input-sm" ng-model="$ctrl.form.modality" ng-options="o as o.name for o in $ctrl.modalityOptions | orderBy:\'name\' track by o.slug" ng-change="$ctrl.onModalityChange()"></select></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-12"><div class="form-group"><label for="devices" translate>.Devices</label><ui-select ng-init="foi_description_attr = (\'environment.foi-description-attr\' | translate)" id="devices" multiple ng-model="$ctrl.form.devices" on-select="$ctrl.onDeviceSelect($item, $model)" on-remove="$ctrl.onDeviceRemove($item, $model)"><ui-select-match><span class="color-bullet" ng-style="{\'background-color\': $item.color}"></span> <strong ng-bind="$item.name"></strong> (<small ng-bind="$item.parent[foi_description_attr]"></small>)</ui-select-match><ui-select-choices placeholder="hello?" group-by="$ctrl.groupByFoi" repeat="o in ($ctrl.deviceOptions | orderBy:\'name\' | filter: $select.search) track by o.id"><span class="color-bullet" ng-style="{\'background-color\': o.color}"></span> <span ng-bind="o.name"></span></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-12"><div class="form-group"><label for="date-range" translate>.Dates range</label><div class="input-group input-group-sm"><span class="input-group-btn"><button class="btn btn-default" type="button" title="Slide backwards" ng-click="$ctrl.onDateRangeRewind()">&#8810;</button></span><app-date-range-picker input-id="date-range" range="$ctrl.form.dateRange" config="$ctrl.uiConfig.dateRangePicker" on-change="$ctrl.onDateRangeChange(newValue, oldValue)"></app-date-range-picker><span class="input-group-btn"><button class="btn btn-default" type="button" title="Slide forwards" ng-click="$ctrl.onDateRangeForward()">&#8811;</button></span></div></div></div></div></aside></div><div class="col-lg-9"><h4 class="title text-center" translate>.Analytics</h4><div class="subtitle text-center">{{$ctrl.subtitle}}</div><nvd3 id="chart" options="$ctrl.uiConfig.chart.options" data="$ctrl.chart" config="$ctrl.uiConfig.chart.config" api="$ctrl.uiConfig.chart.api" class="nvd3-error-chart"></nvd3></div></div></div></div>',
        controller: AnalyticsController,
        controllerAs: '$ctrl'
    });

    /* @ngInject */
    function AnalyticsController($q, $translate, iotService) {
        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {
            $ctrl.translations = {};
            $ctrl.uiConfig = getUiComponentsConfiguration();
            $ctrl.form = getFormModel();

            $ctrl.chart = [];

            $q.all({
                modalityOptions: iotService.getModalities(),
                foiOptions: iotService.getFois(true),
                translations: getTranslations()
            }).then(function (results) {
                var colorScale = d3.scale.category10();

                $ctrl.translations = results.translations;
                $ctrl.modalityOptions = results.modalityOptions;
                $ctrl.deviceOptions = _(results.foiOptions).flatMapDeep('devices').uniq('id').value();
                $ctrl.deviceOptions.forEach(function (device, index) {
                    device.color = colorScale(index);
                });

                $ctrl.form.setDefaults();
                $ctrl.isReady = true;
            });
        };
        $ctrl.$onChanges = function (changesObj) {};
        $ctrl.$onDestroy = function () {};

        $ctrl.onModalityChange = function () {
            updateChart();
        };

        // $ctrl.onDeviceSelect = function() {
        //     updateChart();
        // }


        $ctrl.onDateRangeChange = function (newValue, oldValue) {
            updateChart();
        };

        $ctrl.onDateRangeRewind = function () {
            var dates = $ctrl.form.dateRange,
                diff = dates.endDate.diff(dates.startDate);

            $ctrl.form.dateRange = {
                startDate: dates.startDate.subtract(diff),
                endDate: dates.endDate.subtract(diff)
            };
        };

        $ctrl.onDateRangeForward = function () {
            var dates = $ctrl.form.dateRange,
                diff = dates.endDate.diff(dates.startDate);

            $ctrl.form.dateRange = {
                startDate: dates.startDate.add(diff),
                endDate: dates.endDate.add(diff)
            };
        };

        $ctrl.groupByFoi = function (device) {
            return device.parent[$ctrl.translations['environment.foi-description-attr']];
        };

        /**
        * 
        * @param {*} text 
        */
        function setSubtitle() {
            var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
            var _$ctrl$form$dateRange = $ctrl.form.dateRange,
                startDate = _$ctrl$form$dateRange.startDate,
                endDate = _$ctrl$form$dateRange.endDate,
                subtitle;


            subtitle = text || moment(startDate).format('DD MMM YYYY') + ' - ' + moment(endDate).format('DD MMM YYYY');

            $ctrl.subtitle = subtitle;
        }

        function updateChart() {

            if (!$ctrl.isReady) {
                return;
            }

            iotService.getAnalytics($ctrl.form.modality, $ctrl.form.devices[0], $ctrl.form.dateRange.startDate, $ctrl.form.dateRange.endDate).then(function (data) {
                /* Add data to chart */
                $ctrl.chart.push({ id: $ctrl.form.devices[0].id, key: $ctrl.form.devices[0].name, values: data });
            });

            setSubtitle();
        }

        function getTranslations() {
            return $translate(['environment.foi-description-attr']);
        }

        function getFormModel() {
            return {
                modality: null,
                devices: null,
                dateRange: {
                    startDate: null,
                    endDate: null
                },
                setDefaults: function setDefaults() {
                    this.dateRange = {
                        startDate: moment().startOf('day'),
                        endDate: moment().add(1, 'days').startOf('day')
                    };

                    this.modality = _.find($ctrl.modalityOptions, { slug: 'temperature' });
                    this.devices = [$ctrl.deviceOptions[0]];
                }
            };
        }

        function getUiComponentsConfiguration() {
            var timeFormat;

            timeFormat = d3.time.format.multi([[".%L", function (d) {
                return d.getMilliseconds();
            }], [":%S", function (d) {
                return d.getSeconds();
            }], ["%I:%M", function (d) {
                return d.getMinutes();
            }], ["%I %p", function (d) {
                return d.getHours();
            }], ["%a %d", function (d) {
                return d.getDay() && d.getDate() != 1;
            }], ["%b %d", function (d) {
                return d.getDate() != 1;
            }], ["%B", function (d) {
                return d.getMonth();
            }], ["%Y", function () {
                return true;
            }]]);

            return {
                chart: {
                    api: null,

                    config: {
                        deepWatchOptions: true,
                        deepWatchData: true,
                        debounce: 100
                    },

                    options: {
                        title: { enable: false },
                        subtitle: { enable: false },

                        chart: {
                            type: 'customLineWithFocusChart',
                            height: 500,
                            duration: 500,
                            useInteractiveGuideline: true,
                            margin: { top: 20, right: 60, bottom: 60, left: 80 },
                            defined: function defined(d, i) {
                                return typeof d.mean != 'undefined';
                            },
                            x: function x(d) {
                                return typeof d != 'undefined' ? new Date(d.windows_start) : null;
                            },
                            y: function y(d) {
                                return typeof d != 'undefined' ? d.mean : null;
                            },
                            high: function high(d) {
                                return typeof d != 'undefined' ? d.windows_max : null;
                            },
                            low: function low(d) {
                                return typeof d != 'undefined' ? d.windows_min : null;
                            },
                            xScale: d3.time.scale(),
                            focus: { xScale: d3.time.scale() },
                            xAxis: { tickFormat: timeFormat },
                            x2Axis: { tickFormat: timeFormat },
                            yAxis: { tickFormat: d3.format(',.2f') },
                            y2Axis: { tickFormat: d3.format(',.2f') }
                        }
                    }
                },

                dateRangePicker: {
                    timePicker: true,
                    timePicker24Hour: true,
                    alwaysShowCalendars: false,
                    locale: {
                        format: 'DD/MM/YYYY HH:mm',
                        separator: ' - '
                    },
                    customRanges: ['last-hour', 'last-2-hour', 'last-3-hours', 'last-4-hours', 'last-5-hours', 'last-6-hours']
                }
            };
        }
    }
})();